// extracted by mini-css-extract-plugin
export default {"info":"qX1B9PgsP9","h-rule":"lRH8sr4E8d","hRule":"lRH8sr4E8d","further-resources":"IDIaNO9dWc","furtherResources":"IDIaNO9dWc"};